<template>
    <div class="main-container" v-loading="isLoading" element-loading-text="拼命加载中">
        <SlideShow v-if="imgs.length" :imgs='imgs' @imgClick='bannerImgClicked'></SlideShow>
        <ul class="clearfix tag-list" :class='{"fixed":tagListFixed}' :style="{'padding-left':(tagListFixed&&offsetLeft?offsetLeft:0)+'px'}">
            <li v-for="tag in tags" :key="tag.id" @click="changeTag(tag)" :class="{'active':tag.id===activeTagId}">
                {{tag.typeName}}
            </li>
        </ul>
        <ul v-if='activeTagId!==-2' class="clearfix announcement-list">
            <Announcement v-for="announcement in announcements" :key="announcement.id" :item='announcement' @itemClicked='announceClicked' />
        </ul>
        <section v-if='activeTagId === -2 && courses.announcePublishVOList && courses.announcePublishVOList.length' v-for='courses of goodCourses' :key='courses.id'>
            <h3 class='section-class' v-if='courses.tagName'>
                <hr/>
                <span>{{courses.tagName}}</span>
                <hr/>
            </h3>
            <ul class="clearfix announcement-list">
                <Announcement v-for="(announcement,index) in courses.announcePublishVOList" :key="announcement.id" v-if='index<=3' :item='announcement' @itemClicked='announceClicked' />
            </ul>
        </section>
    </div>
</template>
<script>
    import SlideShow from "./SlideShow";
    import Announcement from "./Announcement";
    import {
        getBannerImgs,
        getAnnounces,
        getTags,
        getGoodCoursesList
    } from "api/academy";
    export default {
        data: function() {
            return {
                offsetLeft: null,
                isLoading: true,
                activeTagId: -2,
                tagListFixed: false,
                announcements: [],
                tags: [
                    {
                        id: -2,
                        typeName: "好课推荐"
                    },
                    {
                        id: -1,
                        typeName: "全部课程"
                    }
                ],
                imgs: [],
                goodCourses: []
            };
        },
        components: { SlideShow, Announcement },
        methods: {
            bannerImgClicked(imgItem) {
                this.$router.push({
                    name: "announceDetail",
                    params: { id: imgItem.announceId }
                });
            },
            alert(message) {
                this.$alert({
                    title: "提示",
                    message: message,
                    showCancelButton: false,
                    closeOnClickModal: false
                });
            },
            changeTag(tag) {
                this.activeTagId = tag.id;
                if (tag.id === -2) {
                    getGoodCoursesList({ bizlineId: this.bizLineId })
                        .then(response => {
                            let data = (response && response.data) || [];
                            if (data && data.length) {
                                let topAnnounces = data.find(announceItem => {
                                    return announceItem.id === -2;
                                });
                                if (
                                    topAnnounces &&
                    (!topAnnounces.announcePublishVOList ||
                      !topAnnounces.announcePublishVOList.length)
                                ) {
                                    this.tags.splice(0, 1);
                                    this.activeTagId = this.tags[0].id;
                                    this.loadAnnounces(this.activeTagId);
                                }
                                this.goodCourses = data;
                            }
                            this.isLoading = false;
                        })
                        .catch(() => {
                            this.isLoading = false;
                        });
                } else {
                    this.loadAnnounces(tag.id);
                }
            },
            loadAnnounces(tagId) {
                if (!this.isLoading) {
                    this.isLoading = true;
                }
                this.announcements.length = 0;
                getAnnounces({ bizlineId: this.bizLineId, contentTag: tagId })
                    .then(response => {
                        if (!response || !response.data) {
                            return;
                        }
                        this.announcements = response.data;
                        this.isLoading = false;
                    })
                    .catch(err => {
                        this.alert((err && err.message) || "网络错误");
                        this.isLoading = false;
                    });
            },
            announceClicked(item) {
                let href = this.$router.resolve({
                    name: "announceDetail",
                    params: { id: item.id }
                }).href;
                if (href) {
                    window.open(href, "_blank");
                }
            },
            handleScroll(ev) {
                let scrollTop =
            window.pageXOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
                let offsetTop = document.querySelector(".tag-list").offsetTop;
                if (scrollTop > offsetTop) {
                    this.offsetLeft =
              document.querySelector(".main-container").offsetLeft + 10;
                    this.tagListFixed = true;
                } else {
                    this.tagListFixed = false;
                }
            }
        },
        created: function() {
            this.bizLineId =
          this.$route.params.bizLineId || this.$route.meta.bizLineId || 2;
            //获取banner图片列表
            getBannerImgs({ bizLineId: this.bizLineId })
                .then(response => {
                    if (response && response.data) {
                        this.imgs = response.data;
                    }
                })
                .catch(err => {
                    this.alert((err && err.message) || "网络错误");
                });
            //获取公告标签
            getTags({ bizLineId: this.bizLineId })
                .then(response => {
                    let tags = response.data;
                    if (tags && tags.length) {
                        this.tags = this.tags.concat(
                            tags.map(tagItem => {
                                return tagItem;
                            })
                        );
                    }
                    this.changeTag(this.tags[0]);
                })
                .catch(err => {
                    this.alert((err && err.message) || "网络错误");
                    this.isLoading = false;
                });
        },
        mounted() {
            window.addEventListener("scroll", this.handleScroll);
        },
        destroyed() {
            window.removeEventListener("scroll", this.handleScroll);
        }
    };
</script>
<style lang="postcss" scoped>
.main-container {
  padding: 15px 10px;
  width: 1040px;
  margin: 0 auto;
  font-family: PingFangSC;
}
.tag-list {
  user-select: none;
  list-style: none;
  margin: 20px 0 0 0;
  padding-left: 0;
  transition: padding, margin 0.2s linear;
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    margin-top: 0;
    padding-top: 11px;
    z-index: 999;
    background-color: white;
    width: 100%;
    box-shadow: 0 2px 20px 0 rgba(173, 189, 197, 0.5);
    li {
      padding-bottom: 8px;
    }
  }
  li {
    margin-right: 40px;
    float: left;
    font-size: 18px;
    line-height: 28px;
    color: #152c3c;
    padding-bottom: 8px;
    border-bottom: 3px white solid;
    &.active {
      font-weight: 500;
      border-bottom-color: #2897ff;
    }
  }
}
.announcement-list {
  list-style: none;
  padding-left: 0;
  display: flex;
  margin: 0;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.section-class {
  font-weight: normal;
  text-align: center;
  margin: 30px 0 0 0;
  font-size: 16px;
  line-height: 25px;
  color: #6e808b;
  hr {
    display: inline-block;
    color: #f2f4f5;
    width: 40px;
    margin: 0 10px;
    vertical-align: middle;
  }
}
</style>




// WEBPACK FOOTER //
// HomePage.vue?70a2587e